<template>
  <div class="home">
    <div id="vdoplayer" v-if="isvdo">
      <i @click="closePlay" class="el-icon-close"></i>
      <video :src="playurl" autoplay controls></video>
    </div>
    <mynav1 :data='nvdata'></mynav1>
    <cthead  :data="headdata"></cthead>
    <mediact  :data="pdctdata"></mediact>
    <myfooter :data='ftdata'></myfooter>
  </div>
</template>
<style>
#vdoplayer {
  width: 100%;
  height: calc(100% - .95rem);
  position: absolute;
  z-index: 11;
  background: rgba(111, 111, 111, .8);
  top: .95rem;
}
#vdoplayer i {
  display: block;
  color: white;
  font-size: .8rem;
  position: absolute;
  right: .2rem;
  top: .2rem;
  cursor: pointer;
}
#vdoplayer video {
  width: 80%;
  height: 70%;
  margin-left: 10%;
  margin-top: 1.5rem;
  background-color: black;
}
</style>
<script>
// @ is an alias to /src
import {cmdata} from '@/assets/data/data'
require('@/assets/zt.css')
import cthead from '@/components/cthead'
import mediact from '@/components/mediact'
import mynav1 from '@/components/mynav1'
import myfooter from '@/components/footer'




export default {
  components: {
    cthead,mediact,mynav1,myfooter
  },
  data () {
    return {
      isvdo: false,
      playurl: '',
      ovscroll: false,
      mdctdata: '',
      pdctdata: '',
      headdata: '',
      menudata: '',
      scrdist: 0,
      ftdata: {
        type: 'media',
        // lcallback: () => {
        //   this.init()
        // }
      },
      nvdata: {
        sindex: 2,
        type: 'media',
        lcallback: (stype) => {
          if (stype) {
            this.setHead(stype)
          }
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {
    closePlay () {
      this.isvdo = false
      this.playurl = ''
    },
    backToTop () {
      window.scrollTo(0,0)
    },
    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
    setHead (type) {
      var item = cmdata['media']
      this.headdata = {
        title: item.title,
        desc: item.desc,
        pic: item.pic,
        wtype: 0,
        type: type,
        category: item.category,
        callback: (ctype) => {
          this.pdctdata = {
            type: ctype,
            data: item.data,
            callback: url => {
              this.isvdo = true
              this.playurl = url
            }
          }
          this.$router.replace({path:'/media',query:{stype: ctype}})
        }
      }

    },
    init () {
      var stype = this.$route.query.stype?this.$route.query.stype:'prods'
      this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
